import React, { useRef } from 'react';
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useTheme } from './lib/theme';
import ErrorBoundary from './components/ErrorBoundary';
import AnalyticsListener from './components/AnalyticsListener';
import PageShell from './components/PageShell';
import WeatherPage from './pages/WeatherPage.jsx';
const TripPage = React.lazy(() => import('./pages/TripPage.jsx'));

const queryClient = new QueryClient();

// Heading is route-aware so PageShell can stay mounted across navigations.
const useRouteHeading = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/trip')) return 'How many layers should I pack for my trip?';
  return 'How many layers should I wear today?';
};

const Shell = () => {
  const heading = useRouteHeading();
  const incrementRef = useRef(() => {});

  return (
    <PageShell
      heading={heading}
      onCount={(increment) => { incrementRef.current = increment; }}
    >
      <Routes>
        <Route path="/" element={<WeatherPage onRecommendationShown={(n) => incrementRef.current(n)} />} />
        <Route
          path="/trip"
          element={
            <React.Suspense fallback={<div className="text-sm text-gray-600 dark:text-gray-400">Loading…</div>}>
              <TripPage onRecommendationShown={(n) => incrementRef.current(n)} />
            </React.Suspense>
          }
        />
      </Routes>
    </PageShell>
  );
};

const App = () => {
  useTheme();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <BrowserRouter>
            <AnalyticsListener />
            <Shell />
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
